<template>
    <div class="pt-3 px-3 pb-1">

        <p v-if="clicks.length == 0" class="text-center">No clicks</p>

        <span v-else>
        
        <!-- Desktop -->
        <table class="datatables-basic table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">IP</th>
                  <th class="pr-4">Browser</th>
                  <th class="pl-4">City</th>
                  <th>Country</th>
                  <th class="first-right">Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(click, index) in clicks" :key="index.id">
              
              <td class="pl-3">
                <a :href="'http://ip-api.com/json/'+click.ip" target="_blank" class="iplink">{{click.ip}}</a>
                <div v-if="click.source"><small><a :href="'mailto:'+click.email" class="iplink">{{click.email}}</a></small></div>
              </td>
              <td class="agent pr-4 pl-0"><span :title="click.agent"><i :class="click.agent_logo+' fa-2x logo'"></i></span></td>
              <td class="pl-4">{{click.city}}</td>
              <td class="pl-0"><img :src="'/images/flags/svg/'+click.country_flag" class="country_flag mr-2" :title="click.country">{{click.country}}</td>
              <td class="pl-0"><timeago
                  :datetime="click.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(click.created_at)"></timeago></td>
            
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">IP • Country • Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(click, index) in clicks" :key="index.id">
  
        <td class="pl-2">
            <div><a :href="'http://ip-api.com/json/'+click.ip" target="_blank" class="iplink">{{click.ip}}</a></div>
            <div>{{`${click.city} - ${click.country}`}}</div>
            <div><timeago
                  :datetime="click.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(click.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>

  </div>
</template> 

<script>
export default {
  props: ['user'],

  data() {
    return {
      clicks: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getClicks();

    Echo.private("clicks_"+this.user.id)
      .listen("AffiliateClick", (event) => {
        this.getClicks();
      });
  },

  methods: {
    getClicks() {
      
      this.loading = true;

      axios.post("/clicks/get", {
        user_id: this.user.id,
      }).
      then((response) => {
        this.clicks = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
a.iplink { font-weight:normal !important; }

.logo { position: relative; top: 0px;}

td.agent { width:70px; }
</style>